export const state = {
  allSteps: [],
}

export const getters = {
  allSteps(state) {
    return state.allSteps
  },
}

export const mutations = {
  SET_ALL_STEPS(state, steps) {
    state.allSteps = steps
  },
}
